import { TDR } from 'tdr-common';

export function isEventVisibleForCard(event: TDR.Event): boolean {
	const sched = event.eventSchedule ?? 'non-recurring';
	if (sched === 'permanent') {
		return true;
	}
	if (sched === 'recurring') {
		return true;
	}
	const dates = event.condition?.value?.dates;
	if (dates?.length) {
		return dates.some((d) => new Date(d) > new Date());
	}
	const betweenDates = event.condition?.value?.betweenDates;
	if (betweenDates?.length === 2) {
		return new Date(betweenDates[1]) >= new Date();
	}
	return true;
}
